import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import clsx from "clsx";
import React, { FC } from "react";

interface RichTextProps {
  raw?: string | null;
  className?: string;
}

export const RichText: FC<RichTextProps> = ({ raw, className }) => {
  return (
    <div className={clsx("rich-text whitespace-break-spaces", className)}>
      {raw &&
        documentToReactComponents(JSON.parse(raw), {
          renderText: (text) => {
            return text
              .split("\n")
              .reduce<(string | JSX.Element | false)[]>((acc, textSegment, index) => {
                return [...acc, index > 0 && <br key={index} />, textSegment];
              }, []);
          },
          renderNode: {
            [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
            [BLOCKS.HEADING_1]: (_, children) => <div className="text-6xl">{children}</div>,
            [BLOCKS.HEADING_2]: (_, children) => <div className="text-5xl">{children}</div>,
            [BLOCKS.HEADING_3]: (_, children) => <h3 className="text-4xl">{children}</h3>,
            [BLOCKS.HEADING_4]: (_, children) => <h4 className="text-3xl">{children}</h4>,
            [BLOCKS.HEADING_5]: (_, children) => <h5 className="text-2xl">{children}</h5>,
            [BLOCKS.HEADING_6]: (_, children) => <h6 className="text-xl">{children}</h6>,
            [BLOCKS.OL_LIST]: (_, children) => <ol className="list-decimal pl-4">{children}</ol>,
            [BLOCKS.UL_LIST]: (_, children) => <ul className="list-disc pl-4">{children}</ul>,
            [BLOCKS.LIST_ITEM]: (_, children) => <li className="my-3">{children}</li>,
            [BLOCKS.QUOTE]: (_, children) => <span className="italic">{children}</span>,
          },
        })}
    </div>
  );
};
